import React from 'react';
import merge from 'classnames';

import { IconCheckMark } from '@/components/icons/IconCheckMark';
import { IconInformation } from '@/components/icons/IconInformation';
import { IconWarningV2 } from '@/components/icons/IconWarningV2';
import { IconWarningV3 } from '@/components/icons/IconWarningV3';

import { Props } from './types';

import styles from './Pill.module.scss';

export const Pill = ({ children, className, showIcon = false, variant = 'information' }: Props) => {
  const getIcon = () => {
    switch (variant) {
      case 'destructive':
        return <IconWarningV2 />;
      case 'information':
        return <IconInformation />;
      case 'success':
        return <IconCheckMark />;
      case 'warning':
        return <IconWarningV3 />;
      default:
        return <IconInformation />;
    }
  };

  return (
    <div
      className={merge(styles.message_box_wrapper, styles[variant], className)}
      data-testid="pill-wrapper"
    >
      {showIcon && getIcon()}
      {children}
    </div>
  );
};
